import { isScrollable } from './isScrollable';
export const getScrollParent = (input) => {
    var _a;
    let node = input;
    if (isScrollable(node)) {
        node = node.parentElement;
    }
    while (node && !isScrollable(node)) {
        node = node.parentElement;
    }
    return (_a = node !== null && node !== void 0 ? node : document.scrollingElement) !== null && _a !== void 0 ? _a : document.documentElement;
};
//# sourceMappingURL=getScrollParent.js.map